import React from 'react';
import { LegalList, LegalNotice, LegalP, LegalPage, LegalSection } from '../components/Legal/LegalPage';

const RefundPolicy: React.FC = () => {
  const updated = 'May 14, 2026';

  return (
    <LegalPage
      title="Refund Policy"
      updated={updated}
      intro="This policy explains how refunds are handled for RideSaathi subscription plans, unlock credits, top-ups, and billing issues."
    >
      <LegalNotice severity="warning">
        Subscription payments are generally non-refundable once access to the plan, ride feed, or unlock credits has been provided.
      </LegalNotice>

      <LegalSection title="1. Subscription payments">
        <LegalP>
          RideSaathi offers subscription plans and related access benefits for drivers and fleet operators. Once plan access is activated or credits are made available, subscription payments are generally non-refundable.
        </LegalP>
        <LegalP>
          Cancellation, if available, stops future renewal. It does not automatically refund the current billing period.
        </LegalP>
      </LegalSection>

      <LegalSection title="2. Duplicate payments and billing issues">
        <LegalP>
          Duplicate payments, failed-payment debits, incorrect billing, or technical payment gateway issues may be reviewed. If approved, the refund may be processed to the original payment method or adjusted as platform credit, depending on the case and payment provider rules.
        </LegalP>
        <LegalList
          items={[
            'A duplicate payment for the same plan or order may be eligible for review.',
            'A technical billing error confirmed by payment records may be eligible for review.',
            'A refund is not guaranteed merely because a ride was not booked, completed, paid, or accepted offline.',
          ]}
        />
      </LegalSection>

      <LegalSection title="3. Unlock credits and top-ups">
        <LegalP>
          Unlock credits and top-ups are generally non-refundable once issued, consumed, or used to reveal ride details. If a technical issue prevents access after a valid payment, contact support for review.
        </LegalP>
      </LegalSection>

      <LegalSection title="4. How to request a refund review">
        <LegalList
          items={[
            'Email support@ridesaathi.in or raise an in-app support request.',
            'Include your name, phone number, account email, payment date, amount, payment reference, and reason.',
            'Submit duplicate payment or technical billing issues as soon as possible after the transaction.',
          ]}
        />
      </LegalSection>

      <LegalSection title="5. Processing timeline">
        <LegalP>
          We review refund requests after checking account access, payment status, gateway records, invoice details, and platform usage. Approved refunds may take additional time depending on the bank, card network, UPI provider, or payment gateway.
        </LegalP>
      </LegalSection>

      <LegalSection title="6. Platform disclaimer">
        <LegalP>
          RideSaathi is only a platform for organizing rides. We do not guarantee ride booking, payment, safety, driver or customer verification, or completion of any ride. Refunds are not provided for offline disputes between drivers, riders, contributors, or third parties unless RideSaathi separately approves a billing-related issue.
        </LegalP>
      </LegalSection>

      <LegalSection title="7. Third-party platform disclaimer">
        <LegalP>
          RideSaathi does not claim partnership, sponsorship, endorsement, or affiliation with WhatsApp, Meta, Google, Apple, or any third-party platform unless officially stated in writing by RideSaathi and the relevant third party.
        </LegalP>
      </LegalSection>
    </LegalPage>
  );
};

export default RefundPolicy;
